import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const TOTAL = 17 * 60 + 34;
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(TOTAL);
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div className="w-full rounded-2xl bg-navy p-4 text-center" role="timer" aria-live="off" data-id="element-20" data-mp="3c1vynen1beqo">
      <p className="flex items-center justify-center gap-2 text-sm font-bold text-white" data-id="element-21" data-mp="3c48o0cv4grdr">
        <TimerIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-22" data-mp="3gymec0uxg8bk" />
        Promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-23" data-mp="372t78wzz9716">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="10cbr7briyrc5" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="10dmy3kg9of7h">
              <span className="min-w-[64px] rounded-xl bg-white px-2 py-2 font-display text-3xl font-extrabold tabular-nums text-danger" data-id="element-26" data-mp="15b6asfxbgjxb">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[11px] font-semibold uppercase text-white/70" data-id="element-27" data-mp="t2ljj7b2zg0o">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-3xl font-extrabold text-white" data-id="element-28" data-mp="17qgaoj9fxcbn">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}